import { styled } from 'next-yak';

import { Card } from '@xing-com/card';
import { scale390, scale440, spaceXL } from '@xing-com/tokens';

import { PRODUCT_CARD_HEIGHT } from '../../product-cards.styled';

export const CardContainer = styled(Card)`
  flex: 1 0 0;
  height: ${PRODUCT_CARD_HEIGHT};
  max-width: ${scale440};
  min-width: ${scale390};
  position: relative;

  & > div:first-child {
    flex: 1;
    gap: ${spaceXL};
  }
`;
